<template>
  <div class="replay-alarm-popup-container">
    <el-table :data="data" style="width: 100%" max-height="260">
      <el-table-column prop="deviceName" :label="'设备' | translateTo"></el-table-column>
      <el-table-column prop="message" :label="'报警内容' | translateTo"></el-table-column>
      <el-table-column prop="beginTime" :label="'报警时间' | translateTo" width="80">
        <template #default="{ row }">
          <span>{{ formatTime(row.beginTime, 'hh:mm:ss') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="deviceTime" :label="'操作' | translateTo" width="60">
        <template #default="{ row }">
          <el-button type="text" @click="replay(row)">{{ '回放' | translateTo }}</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { formatTime, getTime, toTimestamp } from '@/utils/date';

export default {
  inject: ['alarmReplay'],
  props: {
    data: {
      type: Array,
      default: () => ({})
    }
  },
  methods: {
    formatTime,
    replay(row) {
      let { sn, beginTime } = row;
      const now = toTimestamp(Date.now(), 'm');
      beginTime = toTimestamp(beginTime, 'm');
      const m3 = getTime('m') * 3;
      const begin = beginTime - m3;
      let end = beginTime + m3;
      end = end > now ? now : end;
      const rangeDateVal = [begin, end];
      this.alarmReplay({ sn: [sn], rangeDateVal });
    }
  }
};
</script>

<style lang="scss">
.replay-alarm-popup-container {
  position: absolute;
  z-index: 10;
  left: 0;
  top: 0;
  opacity: 0.8;
  max-width: 500px;
  min-width: 430px;
}
</style>
